import React from 'react'
import useFitText from "use-fit-text"

const TextFill = ({ children }) => {
  const { fontSize, ref } = useFitText({ minFontSize: 1 })
  return <div ref={ref} style={{ fontSize }} className="text-fill">{children}</div>
}

export default TextFill
